define.alias("ember-math-helpers/helpers/cbrt", "media/helpers/cbrt");